import { useEffect } from 'react';
import Cookies from 'js-cookie';
import { useTranslation } from 'react-i18next';
import { orderService } from '../services/orderService';
import { useAuth } from '../context/AuthProvider';

export const useFailedOrdersNotice = (setAlertMessages: React.Dispatch<
  React.SetStateAction<Partial<Record<string, string[]>>>
>) => {
  const { t } = useTranslation();
  const auth = useAuth();

  useEffect(() => {
    if (!auth) return;

    const checkFailedOrders = async () => {
      try {
        const lastShown = Cookies.get('last_failed_orders_notice');

        if (lastShown) return;

        const res = await orderService.getFailedOrders();

        if (res?.data?.count > 0 && res?.data?.last_error_at) {

          setAlertMessages({
            messages: [t('failedOrdersNotice', { count: res.data.count })],
          })

          Cookies.set('last_failed_orders_notice', res.data.last_error_at, { expires: 1 });
        }
      } catch (err) {
        console.error('Failed to fetch failed orders summary', err);
      }
    };

    checkFailedOrders();
  }, [auth, t]);
};
